import { combineReducers } from "@reduxjs/toolkit";
import map from "./mapSlice";

const reducer = combineReducers({
	map
});

export default reducer;
